export default __webpack_public_path__ + "static/media/upclose.e7454bc8.jpg";